/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable no-constant-binary-expression */
/* eslint-disable react/function-component-definition */
import React, { useRef, useEffect, useContext } from "react";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { format } from "date-fns";
import { UserContext } from "utils/reducers/user";

interface PackageDetail {
  sealNo: string;
  denomination: string;
  containerType: string;
  containerCode: string;
  sourceLocation: string;
  sourceBarcode: string;
  currency: string;
  value: string;
}

interface CoinBox {
  denomination: string;
  containerType: string;
  containerId: string;
  count: number;
  receivedCount: number;
  discrepancyType: string;
  reason: string;
  description: string;
  remarks: string;
  isValidated: boolean;
}

interface SealedPackage {
  denomination: string;
  sourceLocation: string;
  sourceBarcode: string;
  onwardLocation: string;
  onwardBarcode: string;
  consignmentType: string;
  containerType: string;
  containerId: string;
  sealNo: string;
  currency: string;
  value: string;
  discrepancyType: string;
  reason: string;
  description: string;
  remarks: string;
  isValidated: boolean;
}

interface FieldTeamMember {
  employeeId: string;
  name: string;
  role: string;
  nationality: string;
}

interface DispatchReceiptDetails {
  arrivalTime: string;
  baseBarcode: string;
  baseName: string;
  baseCity: string;
  baseAddress: string;
  attendedDateTime?: string;
  coinsBoxes?: CoinBox[];
  sealedPackages: SealedPackage[];
}

interface Requests {
  locationArrival: string;
  locationName: string;
  locationBarcode: string;
  city: string;
  address: string;
  timeWindow: string;
  attendedDateTime: string;
  locationLeave: string;
  onLocation: string;
  packagesCollected: number;
  packagesDelivered: number;
  pendingReasons: string;
  pendingRemarks: string;
  collectedPackages: PackageDetail[];
  deliveredPackages: PackageDetail[];
}
interface RouteData {
  teamLeaderId: string;
  routeNo: string;
  shift: string;
  operationDate: string;
  vanRegistrationNo: string;
  dispatchDetails: DispatchReceiptDetails;
  requests: Requests[];
  receiptDetails: DispatchReceiptDetails;
  fieldTeam: FieldTeamMember[];
}

const RouteEndReportGenerator: React.FC<{ data: RouteData }> = ({ data }) => {
  const { DisplayName } = useContext(UserContext);
  const excelExportRef = useRef<ExcelExport>(null);
  const excelExportRef2 = useRef<ExcelExport>(null);

  const handleExport = () => {
    if (excelExportRef.current) {
      const options = excelExportRef.current?.workbookOptions();
      const options2 = excelExportRef2.current?.workbookOptions();
      const rows = options?.sheets?.[0]?.rows;
      const rows2 = options2?.sheets?.[0]?.rows;

      const teamLeader = data.fieldTeam.find(
        (member) => member.role === "Team Leader"
      );
      const driver = data.fieldTeam.find((member) => member.role === "Driver");
      const guards = data.fieldTeam.filter((member) => member.role === "Guard");

      const collectedData = data?.dispatchDetails;

      const deliveredData = data?.receiptDetails;

      const table1 = convertToExcelRows(
        collectedData?.sealedPackages?.filter(
          (pkg) => pkg.discrepancyType === "None"
        ),
        "COLLECTED"
      );
      const table2 = convertToExcelRows(
        deliveredData?.sealedPackages?.filter(
          (pkg) => pkg.discrepancyType === "None"
        ),
        "DELIVERED",
        true
      );

      const tables = data?.requests?.map((request) => {
        return [
          ...convertRequestToExcelRow(request),
          {
            type: "data",
            cells: [],
          },
          ...convertPackageToExcelRows(request?.collectedPackages, "COLLECTED"),
          {
            type: "data",
            cells: [],
          },
          ...convertPackageToExcelRows(request?.deliveredPackages, "DELIVERED"),
          {
            type: "data",
            cells: [],
          },
        ];
      });

      rows?.unshift(
        {
          type: "data",
          cells: [
            {
              value: `Date:`,
              bold: true,
            },
            {
              value: format(new Date(), "dd-MMM-yyyy"),
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: `Time:`,
              bold: true,
            },
            {
              value: format(new Date(), "HH:mm:ss"),
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: `SUMMARY TRUCK TO VAULT`,
              bold: true,
              fontSize: 16,
              colSpan: 15,
              textAlign: "center",
            },
          ],
        },
        {
          type: "data",
          cells: [],
        },
        {
          type: "data",
          cells: [
            {
              value: `Route Date:`,
              bold: true,
            },
            {
              value: format(new Date(data.operationDate), "dd-MMM-yyyy"),
            },
            {
              value: `Truck plate:`,
              bold: true,
              index: 11,
            },
            {
              value: data.vanRegistrationNo,
              index: 12,
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: `Route Shift:`,
              bold: true,
            },
            {
              value: data.shift,
            },
            {
              value: `1st crew member:`,
              bold: true,
              index: 11,
            },
            {
              value:
                `${teamLeader?.role}-${teamLeader?.nationality}-${teamLeader?.name}-${teamLeader?.employeeId}` ||
                "",
              index: 12,
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: `Route Number:`,
              bold: true,
            },
            {
              value: data.routeNo,
            },
            {
              value: `2nd crew member:`,
              bold: true,
              index: 11,
            },
            {
              value:
                `${driver?.role}-${driver?.nationality}-${driver?.name}-${driver?.employeeId}` ||
                "",
              index: 12,
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: `3rd crew member:`,
              bold: true,
              index: 11,
            },
            {
              value:
                `${guards?.[0]?.role}-${guards?.[0]?.nationality}-${guards?.[0]?.name}-${guards?.[0]?.employeeId}` ||
                "",
              index: 12,
            },
          ],
        },
        {
          type: "data",
          cells: [],
        },
        ...convertDispatchReceiptToExcelRow(collectedData, "Collection"),
        {
          type: "data",
          cells: [],
        },
        ...table1,
        {
          type: "data",
          cells: [],
        },
        ...convertCoinBoxToExcelRow(
          collectedData?.coinsBoxes || [],
          "Collection"
        ),
        {
          type: "data",
          cells: [],
        },
        ...tables?.flat(),
        ...convertDispatchReceiptToExcelRow(deliveredData, "Delivery"),
        {
          type: "data",
          cells: [],
        },
        ...table2,
        {
          type: "data",
          cells: [],
        },
        ...convertCoinBoxToExcelRow(
          deliveredData?.coinsBoxes || [],
          "Delivery"
        ),
        {
          type: "data",
          cells: [],
        },
        {
          type: "data",
          cells: [
            {
              value: "Signature (Crew 1)",
            },
            {
              value: teamLeader?.name,
              index: 3,
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: "Signature (Crew 2)",
            },
            {
              value: driver?.name,
              index: 3,
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: "Signature (Crew 3)",
            },
            {
              value: guards?.[0]?.name,
              index: 3,
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: "Signature (Vault Empl)",
            },
            {
              value: DisplayName,
              index: 3,
            },
          ],
        },
        {
          type: "data",
          cells: [],
        },
        {
          type: "data",
          cells: [
            {
              value:
                "After signing this receipt, the vault employee is fully responsible for this load.",
              format: "italic",
            },
          ],
        }
      );

      rows2?.unshift(
        {
          type: "data",
          cells: [
            {
              value: `Date:`,
              bold: true,
            },
            {
              value: format(new Date(), "dd-MMM-yyyy"),
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: `Time:`,
              bold: true,
            },
            {
              value: format(new Date(), "HH:mm:ss"),
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: `DISCREPANCY LIST RECEIVE ROUTE`,
              bold: true,
              fontSize: 16,
              colSpan: 15,
              textAlign: "center",
            },
          ],
        },
        {
          type: "data",
          cells: [],
        },
        {
          type: "data",
          cells: [
            {
              value: `Route Date:`,
              bold: true,
            },
            {
              value: format(new Date(data.operationDate), "dd-MMM-yyyy"),
            },
            {
              value: `Truck plate:`,
              bold: true,
              index: 11,
            },
            {
              value: data.vanRegistrationNo,
              index: 12,
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: `Route Shift:`,
              bold: true,
            },
            {
              value: data.shift,
            },
            {
              value: `1st crew member:`,
              bold: true,
              index: 11,
            },
            {
              value:
                `${teamLeader?.role}-${teamLeader?.nationality}-${teamLeader?.name}-${teamLeader?.employeeId}` ||
                "",
              index: 12,
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: `Route Number:`,
              bold: true,
            },
            {
              value: data.routeNo,
            },
            {
              value: `2nd crew member:`,
              bold: true,
              index: 11,
            },
            {
              value:
                `${driver?.role}-${driver?.nationality}-${driver?.name}-${driver?.employeeId}` ||
                "",
              index: 12,
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: `3rd crew member:`,
              bold: true,
              index: 11,
            },
            {
              value:
                `${guards?.[0]?.role}-${guards?.[0]?.nationality}-${guards?.[0]?.name}-${guards?.[0]?.employeeId}` ||
                "",
              index: 12,
            },
          ],
        },
        {
          type: "data",
          cells: [],
        },
        ...convertPendingRequestToExcelRows(
          data?.requests?.filter((i) => i.pendingReasons !== null) || [],
          "Missed Calls"
        ),
        {
          type: "data",
          cells: [],
        },
        ...convertReceiptRequestToExcelRows(
          deliveredData?.sealedPackages?.filter(
            (i) => i.discrepancyType !== "None"
          ) || []
        ),
        {
          type: "data",
          cells: [],
        },
        ...convertCoinBoxToExcelRow(
          deliveredData?.coinsBoxes?.filter(
            (i) => i.discrepancyType !== "None"
          ) || [],
          "Discrepancies"
        ),
        {
          type: "data",
          cells: [],
        },
        {
          type: "data",
          cells: [
            {
              value: "Signature (Crew 1)",
            },
            {
              value: teamLeader?.name,
              index: 3,
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: "Signature (Crew 2)",
            },
            {
              value: driver?.name,
              index: 3,
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: "Signature (Crew 3)",
            },
            {
              value: guards?.[0]?.name,
              index: 3,
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: "Signature (Vault Empl)",
            },
            {
              value: DisplayName,
              index: 3,
            },
          ],
        },
        {
          type: "data",
          cells: [],
        },
        {
          type: "data",
          cells: [
            {
              value:
                "After signing this receipt, the vault employee is fully responsible for this load.",
              format: "italic",
            },
          ],
        }
      );

      if (options.sheets && options2?.sheets?.[0]) {
        options.sheets[1] = options2?.sheets?.[0];
        options.sheets[0].name = `Route ${data.shift} ${data.routeNo} ${data.operationDate.split("T")[0]}`;
        options.sheets[1].name = "Discrepancies";
      }
      excelExportRef.current.save(options);
    }
  };

  const convertToExcelRows = (
    data: SealedPackage[],
    tableTitle?: string,
    isRouteEnd?: boolean
  ) => {
    const rows = [];

    // Add table title
    rows.push({
      type: "data",
      cells: [
        {
          value: tableTitle,
          bold: true,
          fontSize: 14,
          colSpan: 16,
          backgroundColor: "#f0f0f0",
          index: 2,
        },
      ],
    });

    // Add table headers
    rows.push({
      type: "data",
      cells: [
        { value: "Seal No", bold: true, index: 2, background: "#ADD8E6" },
        {
          value: "Code",
          bold: true,
          index: 3,
          background: "#ADD8E6",
        },
        {
          value: "Bag Type",
          bold: true,
          index: 4,
          background: "#ADD8E6",
        },
        ...(isRouteEnd
          ? [
              {
                value: "To Barcode",
                bold: true,
                index: 5,
                background: "#ADD8E6",
              },
              {
                value: "To Location",
                bold: true,
                index: 6,
                background: "#ADD8E6",
              },
              {
                value: "From Barcode",
                bold: true,
                index: 7,
                background: "#ADD8E6",
              },
              {
                value: "From Location",
                bold: true,
                index: 8,
                background: "#ADD8E6",
              },
              {
                value: "Currency",
                bold: true,
                index: 9,
                background: "#ADD8E6",
              },
              { value: "Value", bold: true, index: 10, background: "#ADD8E6" },
            ]
          : [
              {
                value:
                  tableTitle === "COLLECTED" ? "To Barcode" : "From Barcode",
                bold: true,
                index: 5,
                background: "#ADD8E6",
              },
              {
                value:
                  tableTitle === "COLLECTED" ? "To Location" : "From Location",
                bold: true,
                index: 6,
                background: "#ADD8E6",
              },
              {
                value: "Currency",
                bold: true,
                index: 7,
                background: "#ADD8E6",
              },
              { value: "Value", bold: true, index: 8, background: "#ADD8E6" },
            ]),
      ],
    });

    // Add table data rows
    data?.forEach((item) => {
      rows.push({
        type: "data",
        cells: [
          { value: item.sealNo || "-", index: 2 },
          { value: item.containerId || "-", index: 3 },
          { value: item.containerType || "-", index: 4 },
          {
            value: item.onwardBarcode || "-",
            index: 5,
          },
          {
            value: item.onwardLocation || "-",
            index: 6,
          },
          ...(isRouteEnd
            ? [
                { value: item.sourceBarcode || "-", index: 7 },
                { value: item.sourceLocation || "-", index: 8 },
                { value: item.currency || "-", index: 9 },
                { value: item.value || "-", index: 10 },
              ]
            : [
                { value: item.currency || "-", index: 7 },
                { value: item.value || "-", index: 8 },
              ]),
        ],
      });
    });

    return rows;
  };

  const convertPackageToExcelRows = (
    data: PackageDetail[],
    tableTitle?: string
  ) => {
    const rows = [];

    // Add table title
    rows.push({
      type: "data",
      cells: [
        {
          value: tableTitle,
          bold: true,
          fontSize: 14,
          colSpan: 16,
          backgroundColor: "#f0f0f0",
          index: 2,
        },
      ],
    });

    // Add table headers
    rows.push({
      type: "data",
      cells: [
        { value: "Seal No", bold: true, index: 2, background: "#ADD8E6" },

        {
          value: "Code",
          bold: true,
          index: 3,
          background: "#ADD8E6",
        },
        {
          value: "Bag Type",
          bold: true,
          index: 4,
          background: "#ADD8E6",
        },
        { value: "Denomination", bold: true, index: 5, background: "#ADD8E6" },
        {
          value: tableTitle === "COLLECTED" ? "To Barcode" : "From Barcode",
          bold: true,
          index: 6,
          background: "#ADD8E6",
        },
        {
          value: tableTitle === "COLLECTED" ? "To Location" : "From Location",
          bold: true,
          index: 7,
          background: "#ADD8E6",
        },
        { value: "Currency", bold: true, index: 8, background: "#ADD8E6" },
        { value: "Value", bold: true, index: 9, background: "#ADD8E6" },
      ],
    });

    // Add table data rows
    data?.forEach((item) => {
      rows.push({
        type: "data",
        cells: [
          { value: item.sealNo || "-", index: 2 },
          { value: item.containerCode || "-", index: 3 },
          { value: item.containerType || "-", index: 4 },
          { value: item.denomination || "-", index: 5 },
          { value: item.sourceBarcode || "-", index: 6 },
          { value: item.sourceLocation || "-", index: 7 },
          { value: item.currency || "-", index: 8 },
          { value: item.value || "-", index: 9 },
        ],
      });
    });

    return rows;
  };

  const convertDispatchReceiptToExcelRow = (
    data: DispatchReceiptDetails,
    type?: string
  ) => {
    const rows = [];

    // Add table headers
    rows.push({
      type: "data",
      cells: [
        { value: "Arr. time", bold: true, index: 1, background: "#ADD8E6" },
        {
          value: "Location number",
          bold: true,
          index: 2,
          background: "#ADD8E6",
        },
        { value: "Name", bold: true, index: 3, background: "#ADD8E6" },
        { value: "Street", bold: true, index: 4, background: "#ADD8E6" },
        {
          value: "Time window(s)",
          bold: true,
          index: 5,
          background: "#ADD8E6",
        },
        { value: "Town", bold: true, index: 6, background: "#ADD8E6" },
        { value: "On loc.", bold: true, index: 7, background: "#ADD8E6" },
        { value: "Amnt coll", bold: true, index: 8, background: "#ADD8E6" },
        { value: "Amnt del", bold: true, index: 9, background: "#ADD8E6" },
        { value: "Rsn code", bold: true, index: 10, background: "#ADD8E6" },
        { value: "T", bold: true, index: 11, background: "#ADD8E6" },
        { value: "L", bold: true, index: 12, background: "#ADD8E6" },
      ],
    });

    // Add data row
    rows.push({
      type: "data",
      cells: [
        { value: data?.arrivalTime || "-", bold: true, index: 1 },
        { value: data?.baseBarcode || "-", bold: true, index: 2 },
        { value: data?.baseName || "-", bold: true, index: 3 },
        { value: data?.baseAddress || "-", bold: true, index: 4 },
        { value: "", bold: true, index: 5 },
        { value: data?.baseCity || "-", bold: true, index: 6 },
        { value: data?.attendedDateTime, bold: true, index: 7 },
        {
          value:
            type === "Collection"
              ? data?.sealedPackages?.filter(
                  (i) => i.discrepancyType === "None"
                )?.length
              : 0,
          bold: true,
          index: 8,
        },
        {
          value:
            type === "Delivery"
              ? data?.sealedPackages?.filter(
                  (i) => i.discrepancyType === "None"
                )?.length
              : 0,
          bold: true,
          index: 9,
        },
        { value: "", bold: true, index: 10 },
        { value: "", bold: true, index: 11 },
        { value: "", bold: true, index: 12 },
      ],
    });

    return rows;
  };

  const convertRequestToExcelRow = (data: Requests) => {
    const rows = [];

    // Add table headers
    rows.push({
      type: "data",
      cells: [
        { value: "Arr. time", bold: true, index: 1, background: "#ADD8E6" },
        {
          value: "Location number",
          bold: true,
          index: 2,
          background: "#ADD8E6",
        },
        { value: "Name", bold: true, index: 3, background: "#ADD8E6" },
        { value: "Street", bold: true, index: 4, background: "#ADD8E6" },
        {
          value: "Time window(s)",
          bold: true,
          index: 5,
          background: "#ADD8E6",
        },
        { value: "Town", bold: true, index: 6, background: "#ADD8E6" },
        { value: "On loc.", bold: true, index: 7, background: "#ADD8E6" },
        { value: "On leave.", bold: true, index: 8, background: "#ADD8E6" },
        { value: "Amnt coll", bold: true, index: 9, background: "#ADD8E6" },
        { value: "Amnt del", bold: true, index: 10, background: "#ADD8E6" },
        { value: "Rsn code", bold: true, index: 11, background: "#ADD8E6" },
        { value: "T", bold: true, index: 12, background: "#ADD8E6" },
        { value: "L", bold: true, index: 13, background: "#ADD8E6" },
      ],
    });

    // Add data row
    rows.push({
      type: "data",
      cells: [
        { value: data?.locationArrival || "-", bold: true, index: 1 },
        { value: data?.locationBarcode || "-", bold: true, index: 2 },
        { value: data?.locationName || "-", bold: true, index: 3 },
        { value: data?.address || "-", bold: true, index: 4 },
        { value: data?.timeWindow || "-", bold: true, index: 5 },
        { value: data?.city || "-", bold: true, index: 6 },
        {
          value: data?.onLocation || "-",
          bold: true,
          index: 7,
        },
        { value: data?.locationLeave || "-", bold: true, index: 8 },
        { value: data?.packagesCollected || "-", bold: true, index: 9 },
        { value: data?.packagesDelivered || "-", bold: true, index: 10 },
        { value: data?.pendingReasons || "-", bold: true, index: 11 },
        { value: "", bold: true, index: 12 },
        { value: "", bold: true, index: 13 },
      ],
    });

    return rows;
  };

  const convertPendingRequestToExcelRows = (
    data: Requests[],
    tableTitle?: string
  ) => {
    const rows = [];

    // Add table title
    rows.push({
      type: "data",
      cells: [
        {
          value: tableTitle,
          bold: true,
          fontSize: 14,
          colSpan: 16,
          backgroundColor: "#f0f0f0",
          index: 1,
        },
      ],
    });

    // Add table headers
    rows.push({
      type: "data",
      cells: [
        {
          value: "Location number",
          bold: true,
          index: 1,
          background: "#ADD8E6",
        },
        {
          value: "Name",
          bold: true,
          index: 2,
          background: "#ADD8E6",
        },
        { value: "Street", bold: true, index: 3, background: "#ADD8E6" },
        { value: "Town", bold: true, index: 4, background: "#ADD8E6" },
        {
          value: "Reason",
          bold: true,
          index: 5,
          background: "#ADD8E6",
        },
        {
          value: "Pending Remarks",
          bold: true,
          index: 6,
          background: "#ADD8E6",
        },
      ],
    });

    // Add table data rows
    data?.forEach((item) => {
      rows.push({
        type: "data",
        cells: [
          { value: item.locationBarcode || "-", index: 1 },
          { value: item.locationName || "-", index: 2 },
          { value: item.address || "-", index: 3 },
          { value: item.city || "-", index: 4 },
          { value: item.pendingReasons || "-", index: 5 },
          { value: item.pendingRemarks || "-", index: 6 },
        ],
      });
    });

    return rows;
  };

  const convertReceiptRequestToExcelRows = (data: SealedPackage[]) => {
    const rows = [];

    // Add table headers
    rows.push({
      type: "data",
      cells: [
        {
          value: "Pack number",
          bold: true,
          index: 1,
          background: "#ADD8E6",
        },
        {
          value: "Description",
          bold: true,
          index: 2,
          background: "#ADD8E6",
        },
        {
          value: "Code",
          bold: true,
          index: 3,
          background: "#ADD8E6",
        },
        {
          value: "Bag Type",
          bold: true,
          index: 4,
          background: "#ADD8E6",
        },

        {
          value: "Location Number",
          bold: true,
          index: 5,
          background: "#ADD8E6",
        },
        { value: "Location Name", bold: true, index: 6, background: "#ADD8E6" },
      ],
    });

    // Add table data rows
    data?.forEach((item) => {
      rows.push({
        type: "data",
        cells: [
          { value: item.sealNo || "-", index: 1 },
          { value: item.discrepancyType || "-", index: 2 },
          { value: item.containerId || "-", index: 3 },
          { value: item.containerType || "-", index: 4 },
          { value: item.sourceBarcode || "-", index: 5 },
          { value: item.sourceLocation || "-", index: 6 },
        ],
      });
    });

    return rows;
  };

  const convertCoinBoxToExcelRow = (data: CoinBox[], tableTitle?: string) => {
    const rows = [];

    // Add table headers
    rows.push({
      type: "data",
      cells: [
        { value: "Item type", bold: true, index: 2, background: "#ADD8E6" },
        { value: "Code", bold: true, index: 3, background: "#ADD8E6" },
        { value: "Bag Type", bold: true, index: 4, background: "#ADD8E6" },
        { value: "Denomination", bold: true, index: 5, background: "#ADD8E6" },
        {
          value:
            tableTitle === "Collection"
              ? "To Collect"
              : tableTitle === "Delivery"
                ? "To Deliver"
                : "Expected",
          bold: true,
          index: 6,
          background: "#ADD8E6",
        },
        {
          value:
            tableTitle === "Collection"
              ? "Collected"
              : tableTitle === "Delivery"
                ? "Delivered"
                : "Actual",
          bold: true,
          index: 7,
          background: "#ADD8E6",
        },
      ],
    });

    // Add table data rows
    data?.forEach((item) => {
      rows.push({
        type: "data",
        cells: [
          { value: "Coins", index: 2 },
          { value: item.containerId || "-", index: 3 },
          { value: item.containerType || "-", index: 4 },
          { value: item.denomination || "-", index: 5 },
          { value: item.count || 0, index: 6 },
          { value: item.receivedCount || 0, index: 7 },
        ],
      });
    });

    return rows;
  };

  useEffect(() => {
    if (data) {
      handleExport();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <>
      <ExcelExport
        ref={excelExportRef}
        fileName={`Route_End_Report_${data.operationDate.split("T")[0]}_${data.shift}_${data.routeNo}.xlsx`}
      />
      <ExcelExport ref={excelExportRef2} />
    </>
  );
};

export default RouteEndReportGenerator;
